import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-08d62746"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_swiper = _resolveComponent("swiper");

  return _openBlock(), _createBlock(_component_swiper, {
    autoplay: $setup.swiper_option.autoplay,
    loop: $setup.swiper_option.loop,
    speed: $setup.swiper_option.speed,
    pagination: $setup.swiper_option.pagination
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.imgUrl,
              alt: item.id
            }, null, 8, _hoisted_1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["autoplay", "loop", "speed", "pagination"]);
}